import { useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

import { openWebView, logCardClick } from '../../utils/NativeWebView';
import { opentItent } from '../../utils/ObChat';
import { cardInOut } from '../../animations/PageAnimations';
import { useAppDispatch } from '../../hooks';
import { openMsgModal } from '../../store/MessageModalSlice';

import type { ICard } from '../../types';


import './VerticalCard.scss';

const VerticalCard = ({ id, index, title, description, image, type, link = '', textClose, messageData, disclosure, textBtn }: ICard) => {

  const dispatch = useAppDispatch();

  const navigate = useNavigate();
  const handleClick = () => {
    logCardClick(id, title, type, link);

    switch (type) {
      case 'link':
        navigate(link);
        break;
      case 'web':
        openWebView(link, textClose);
        break;
      case 'chatbot':
        opentItent(link);
        break;
      case 'message':
        messageData && dispatch(openMsgModal(messageData));
        break;
    }
  };

  return (
    <motion.div
      key={id}
      custom={index}
      initial="initial"
      animate="animate"
      exit="exit"
      variants={cardInOut}
      onClick={handleClick}
      className="relative h-full"
      whileTap={{ scale: 0.95 }}
    >

      <div className="bg-white rounded-3xl border-2 border-orange flex flex-col items-center px-6 xl:px-8 py-6 pb-8 h-full justify-around gap-6 xl:gap-8">
        <div>
          <h2 className="text-3xl leading-tight text-center mt-0">{title}</h2>
          <div className="mt-3 w-full">
            {image && <img className="select-none rounded-2xl" src={image} alt="" />}
          </div>
          <p className="mt-4 leading-tight text-base xl:text-lg pr-4">{description}</p>
        </div>
        <div className="flex-grow flex flex-col items-center justify-end">
          {textBtn && <div className="text-center mx-auto inline bg-purple rounded-full py-2.5 px-8 text-white text-xl font-medium">
            {textBtn}
          </div>}
          {disclosure && <p className="text-xs mt-5 pr-8 -mb-2">{disclosure}</p>}
        </div>

      </div>

    </motion.div>
  );
};
export default VerticalCard;

